import { Box, BoxProps, Typography, styled } from "@mui/material";
import { prefixClassName } from "@smartrr/shared/components/primitives";
import { typedLocalize } from "@smartrr/shared/utils/sharedTranslations/localize";
import React from "react";

const Wrapper = styled(Box)`
  align-items: center;
  background-color: ${props => props.theme.modernPageBackground};
  border-radius: 25px;
  display: flex;
  justify-content: center;
  margin-top: 15px;
  width: 100%;
`;

export const NoProducts = ({ ...props }: BoxProps) => (
  <Wrapper className={prefixClassName("addon-no-products")} {...props}>
    <Typography variant="caption1" sx={{ opacity: "70%" }}>
      {typedLocalize("general.nullProductsFound")}
    </Typography>
  </Wrapper>
);
